{
	/* SET_LOGIN | SET_EMAIL_AND_PASSWORD | SET_EMAIL */
}

export const SET_EMAIL_AND_PASSWORD = 'SET_EMAIL_AND_PASSWORD'
export const SET_LOGIN = 'SET_LOGIN'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_PASSWORD = 'SET_PASSWORD'
